<div class="pt-0">
  <div class="mb-5 flex items-center justify-between">
    <h5 appDynamicFontSize="subtitle" class="font-semibold dark:text-white-light">{{ 'title_profile' | translate }}</h5>
  </div>
  <div>
    <form [formGroup]="profileForm" class="mb-5 rounded-md border border-[#ebedf2] bg-white p-4 dark:border-[#191e3a] dark:bg-[#0e1726]">
      <div class="flex flex-col sm:flex-row">
        <div class="mb-5 w-full sm:w-2/12 ltr:sm:mr-4 rtl:sm:ml-4">
          <img
            [src]="profile_pic ? apiUrl + '/' + profile_pic : 'assets/images/user.png'"
            alt
            class="mx-auto h-20 w-20 rounded-full object-cover md:h-32 md:w-32"
          />
          <input type="file" class="mt-2" (change)="onProfilePictureSelected($event)" accept="image/*" />
          <button type="button" class="btn btn-primary mt-2" (click)="uploadProfilePicture()" appDynamicFontSize="body">
            {{ 'profile_form_pic_upload' | translate }}
          </button>
        </div>
        <div class="grid flex-1 grid-cols-1 gap-5 sm:grid-cols-2">
          <div>
            <label for="first_name" class="form-label">{{ 'profile_form_first_name' | translate }}</label>
            <input type="text" class="form-input" id="first_name" formControlName="first_name" />
            @if (profileForm.get('first_name')?.invalid && (profileForm.get('first_name')?.dirty || profileForm.get('first_name')?.touched)) {
            <div>
              @if (profileForm.get('first_name')?.errors?.['required']) {
              <div class="text-red-500">
                {{ 'profile_form_first_name_req_msg' | translate }}
              </div>
              }
            </div>
            }
          </div>
          <div>
            <label for="last_name" class="form-label">{{ 'profile_form_last_name' | translate }}</label>
            <input type="text" class="form-input" id="last_name" formControlName="last_name" />
            @if (profileForm.get('last_name')?.invalid && (profileForm.get('last_name')?.dirty || profileForm.get('last_name')?.touched)) {
            <div>
              @if (profileForm.get('last_name')?.errors?.['required']) {
              <div class="text-red-500">
                {{ 'profile_form_last_name_req_msg' | translate }}
              </div>
              }
            </div>
            }
          </div>
          <div>
            <label for="dob" class="form-label">{{ 'profile_form_dob' | translate }}</label>
            <input type="text" class="form-input" id="dob" appFlatpickr="date" formControlName="dob" />
            @if (profileForm.get('dob')?.invalid && (profileForm.get('dob')?.dirty || profileForm.get('dob')?.touched)) {
            <div>
              @if (profileForm.get('dob')?.errors?.['required']) {
              <div class="text-red-500">{{ 'profile_form_dob_req_msg' | translate }}</div>
              }
            </div>
            }
          </div>
          <div>
            <label for="country_code" class="form-label">{{ 'profile_form_country_code' | translate }}</label>
            <select class="form-input" id="country_code" formControlName="country_code" (change)="onCountryCodeChange()">
              <option value disabled>{{ 'select_any' | translate }}</option>
              @for (code of countryCodes; track code) {
              <option [value]="code">{{ code }}</option>
              }
            </select>
            @if (profileForm.get('country_code')?.invalid && (profileForm.get('country_code')?.dirty || profileForm.get('country_code')?.touched)) {
            <div>
              @if (profileForm.get('country_code')?.errors?.['required']) {
              <div class="text-red-500">
                {{ 'profile_form_country_code_req_msg' | translate }}
              </div>
              }
            </div>
            }
          </div>

          <div>
            <label for="phone_number" class="form-label">{{ 'profile_form_phnum' | translate }}</label>
            <input type="text" class="form-input" id="phone_number" formControlName="phone_number" />
            @if (profileForm.get('phone_number')?.invalid && (profileForm.get('phone_number')?.dirty || profileForm.get('phone_number')?.touched)) {
            <div>
              @if (profileForm.get('phone_number')?.errors?.['required']) {
              <div class="text-red-500">{{ 'profile_form_phnum_req_msg' | translate }}</div>
              }
            </div>
            }
          </div>
          <div>
            <label for="gender" class="form-label">{{ 'profile_form_gender' | translate }}</label>
            <select class="form-select" id="gender" formControlName="gender">
              <option value>{{ 'select_any' | translate }}</option>
              <option value="male">{{ 'profile_form_gender_option_1' | translate }}</option>
              <option value="female">{{ 'profile_form_gender_option_2' | translate }}</option>
              <option value="other">{{ 'profile_form_gender_option_3' | translate }}</option>
            </select>
            @if (profileForm.get('gender')?.invalid && (profileForm.get('gender')?.dirty || profileForm.get('gender')?.touched)) {
            <div>
              @if (profileForm.get('gender')?.errors?.['required']) {
              <div class="text-red-500">{{ 'profile_form_gender_req_msg' | translate }}</div>
              }
            </div>
            }
          </div>
          <div>
            <label for="user_time_zone" class="form-label">{{ 'profile_form_timezone' | translate }}</label>
            <input type="text" class="form-input" id="user_time_zone" formControlName="user_time_zone" [readonly]="true" />
            @if (profileForm.get('user_time_zone')?.invalid && (profileForm.get('user_time_zone')?.dirty || profileForm.get('user_time_zone')?.touched)) {
            <div>
              @if (profileForm.get('user_time_zone')?.errors?.['required']) {
              <div class="text-red-500">
                {{ 'profile_form_timezone_req_msg' | translate }}
              </div>
              }
            </div>
            }
          </div>
          <div>
            <label for="address" class="form-label">{{ 'profile_form_address' | translate }}</label>
            <textarea class="form-input" id="address" rows="3" formControlName="address"></textarea>
            @if (profileForm.get('address')?.invalid && (profileForm.get('address')?.dirty || profileForm.get('address')?.touched)) {
            <div>
              @if (profileForm.get('address')?.errors?.['required']) {
              <div class="text-red-500">{{ 'profile_form_address_req_msg' | translate }}</div>
              }
            </div>
            }
          </div>

          <div class="mt-3 sm:col-span-2">
            <button type="button" class="btn btn-primary" (click)="updateProfile()" appDynamicFontSize="body">
              {{ 'update' | translate }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
